import React, { Component } from 'react';
import { Form, Input } from 'antd';
import { FormLayout, SelectQuery } from '@/components';
import { CHECK_name, CHECK_phone } from '@/shared/reqexp';
class SearchOptions extends Component {
    render() {
        const { isSeller } = this.props;
        const { getFieldDecorator } = this.props.form;
        return isSeller ? (<FormLayout form={this.props.form} onSearch={this.props.onChange}>
        <Form.Item label="经销商名称">
          {getFieldDecorator('souCheCode')(<SelectQuery labelInValue={false}/>)}
        </Form.Item>
      </FormLayout>) : (<FormLayout form={this.props.form} onSearch={this.props.onChange}>
        <Form.Item label="经销商名称">
          {getFieldDecorator('userName', {
            rules: [
                {
                    validator: CHECK_name(20),
                },
            ],
        })(<Input placeholder="请输入经销商名称"/>)}
        </Form.Item>
        <Form.Item label="手机号">
          {getFieldDecorator('mobile', {
            rules: [
                {
                    pattern: CHECK_phone,
                    message: '请输入正确格式的手机号',
                },
            ],
        })(<Input placeholder="请输入手机号"/>)}
        </Form.Item>
      </FormLayout>);
    }
}
export default Form.create()(SearchOptions);
